import { render, staticRenderFns } from "./customer-current-info.vue?vue&type=template&id=7aaf7100&"
import script from "./customer-current-info.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-current-info.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports